<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <span>
        <a-icon type="wallet" class="margin-right-small" />
        Invoice PO / WO
      </span>
      <a-button @click="handleReload" size="small" icon="reload"></a-button>
    </div>
    <div class="wrapper-body">
      <a-card>
        <div style="display: none">
          <a-select placeholder="Ex: Need Process ... " v-model="tabs.active" :disabled="true" @change="moreSearch"
            class="width-full" initialValue="process" allowClear>
            <a-select-option value="needprocess">needprocess</a-select-option>
            <a-select-option value="invoice_list">Invoice List</a-select-option>
            <a-select-option value="cancel_list">Canceled</a-select-option>
          </a-select>
        </div>
        <a-row :gutter="16">
          <a-col :xs="{ span: 24 }" :lg="{ span: 17 }">
            <a-input-search v-model="search" placeholder="Quick Search" />
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 7 }">
            <div style="width:100%;text-align:left">
              <a-button :class="getScreen ? 'margin-top' : ''" :icon="advancedsearch == 'display:none' ? 'down' : 'up'"
                @click="handleshowMore">{{
                  advancedsearch == "display:none" ? "More" : "Less"
                }}</a-button>
              &nbsp;
              <!-- <a-popover title="Select Action Create" trigger="click" placement="bottomRight" >
              <ul class="m-list-wrapper" slot="content">
                -- <li>
                  <a-button type="dashed" class="m-width-full"
                    @click="handleCreateGeneral('AP')">Invoice Account Pay</a-button>
                </li> --
                <li>
                  <a-button type="dashed" class="m-width-full"
                    @click="handleCreateGeneral('AD')">Invoice Addendum</a-button>
                </li>
              </ul> -->
              <!-- @click="handleCreateGeneralAddendum" -->
              <a-button type="primary" icon="plus" @click="handleCreateGeneral('AD')">
                Inv. Addendum
              </a-button>
              <!-- </a-popover> -->
            </div>
          </a-col>
        </a-row>
        <a-row :style="advancedsearch" :gutter="16" class="margin-top">
          <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
            <div class="m-form-item-wrapper">
              <label>Transaction Date</label>
              <a-range-picker :placeholder="['Start Date', 'End Date']" v-model="transactionDt"
                :format="getDefaultDateFormat" allowClear />
            </div>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
            <div class="m-form-item-wrapper">
              <label>Transaction Type</label>
              <a-select placeholder="Ex: All Transaction ... " v-model="typetransaction" class="width-full"
                initialValue="all">
                <a-select-option value="all">All transaction</a-select-option>
                <a-select-option value="PO">PO</a-select-option>
                <a-select-option value="WO">WO</a-select-option>
                <!-- <a-select-option value="Adendum">Adendum</a-select-option> -->
              </a-select>
            </div>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
            <div class="m-form-item-wrapper">
              <label>Type Invoice</label>
              <a-select placeholder="Ex: All Transaction ... " v-model="typeinvoice" class="width-full" initialValue="all"
                :disabled="tabs.active == 'needprocess'">
                <a-select-option value="all">All Type</a-select-option>
                <a-select-option value="Account Pay">Invoice Account Pay</a-select-option>
                <a-select-option value="Adendum">Invoice Adendum</a-select-option>
              </a-select>
            </div>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
            <div class="m-form-item-wrapper">
              <label>Supplier</label>
              <a-select showSearch v-model="supplier_nm" placeholder="Select Supplier Name" class="width-full"
                initialValue="delivered" allowClear :filterOption="filterOption">
                <a-select-option v-for="item in listSuplier" :key="item.nama_supplier" :value="item.nama_supplier">{{
                  item.nama_supplier }}</a-select-option>
              </a-select>
            </div>
          </a-col>
          <!-- <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
            <div
              v-if="tabs.active == 'needprocess'"
              class="m-form-item-wrapper"
            >
              <label>Revised Status</label>
              <a-select
                showSearch
                v-model="revisedStatus"
                placeholder="Select Status"
                class="width-full"
                initialValue="undefined"
                allowClear
                :filterOption="filterOption"
              >
                <a-select-option value="all">All</a-select-option>
                <a-select-option value="Revised">Revisable</a-select-option>
                <a-select-option value="Revised Disabled"
                  >Can't Revise</a-select-option
                >
                <a-select-option value="Revised On Process"
                  >Revise On Process</a-select-option
                >
              </a-select>
            </div>
          </a-col> -->
        </a-row>
      </a-card>
      <div class="bordered">
        <a-tabs class="custom-tabs" :activeKey="tabs.active" @change="handleTab">
          <a-tab-pane key="needprocess">
            <template slot="tab">
              <span>Need Process</span>&nbsp;
              <a-badge class="m-badge m-badge-small" :count="needProcess.length" :numberStyle="{ backgroundColor: 'red' }"
                v-if="needProcess.length > 0">
              </a-badge>
            </template>
            <a-table :rowKey="(record, index) => { return index.toString(); }" size="small" bordered :scroll="{ x: 1300 }"
              :columns="columns.needProcess" :dataSource="needProcess" :loading="tabs.loading">
              <template slot="nomor" slot-scope="text, data, index">
                <span>{{ index + 1 }}</span>
              </template>
              <template slot="value" slot-scope="text, data">
                <div>{{ formatCurrency('IDR', data.value_idr) }}</div>
                <small v-if="data.mata_uang!='IDR'">
                  {{ formatCurrency(data.mata_uang,data.value) }}
                </small>
              </template>
              <template slot="sisatransfer" slot-scope="text, data">
                <div>{{
                  formatCurrency(
                    'IDR',
                    data.sisa_trf_idr.replace("e-", "")
                  )
                }}</div>
                <small v-if="data.mata_uang!='IDR'">
                  {{ formatCurrency(data.mata_uang,data.sisa_trf) }}
                </small>
              </template>
              <template slot="aksi" slot-scope="text, data">
                <a-button-group>
                  <a-button @click="handleManifestRefNedProcess(data)" icon="file"></a-button>
                  <!-- <a-popover title="Select Action Create" trigger="click" placement="bottomRight" >
                    <ul class="m-list-wrapper" slot="content">
                      <li>
                        <a-button type="dashed" class="m-width-full"
                          @click="handleCreate(data)">Invoice Account Pay</a-button>
                      </li>
                      <li>
                        <a-button type="dashed" class="m-width-full"
                          @click="handleCreateAddendum(data)">Invoice Addendum</a-button>
                      </li>
                    </ul> -->
                  <a-button v-if="data.button_aksi == 'Revised'"
                    :loading="loading.revisedkey == data.id && loading.revised" @click="handleRevisedLink(data)"
                    type="danger" icon="edit"></a-button>
                  <a-button type="primary" @click="handleCreate(data)"><a-icon type="plus" />Create</a-button>
                  <!-- </a-popover> -->
                </a-button-group>
              </template>
            </a-table>
          </a-tab-pane>
          <a-tab-pane tab="Invoice List" key="invoice_list">
            <a-table :rowKey="(record, index) => { return index.toString(); }" size="small" bordered :scroll="{ x: 1300 }"
              :columns="columns.invoice_list" :dataSource="invoice_list" :loading="tabs.loading">
              <template slot="nomor" slot-scope="text, data, index">
                <span>{{ index + 1 }}</span>
              </template>
              <template slot="createBy" slot-scope="text, data">
                <h4 class="margin-remove">{{ data.tlc_create }}</h4>
                <span>{{
                  moment(data.create_dt).format(getDefaultDateFormat)
                }}</span>
              </template>
              <template slot="duedate" slot-scope="text, data">
                <span>{{
                  moment(data.due_date).format(getDefaultDateFormat)
                }}</span>
              </template>
              <template slot="value" slot-scope="text, data">
                <div>{{ formatCurrency('IDR', data.invoice_value) }}</div>
                <small v-if="data.currency_label!=='IDR'">{{ formatCurrency(data.currency_label, data.value_label) }}</small>
              </template>
              <template slot="nama_supplier" slot-scope="text, data">
                <span>{{ data.nama_supplier }}</span><br />
                <i><small>Alamat : {{ data.alamat_supplier }}</small></i>
              </template>
              <template slot="aksi" slot-scope="text, data">
                <a-button-group>
                  <a-tooltip placement="bottomRight">
                    <template slot="title">
                      <span>View Manifest</span>
                    </template>
                    <a-button @click="handleManifest(data)" icon="file"></a-button>
                  </a-tooltip>
                  <a-tooltip placement="bottomRight">
                    <template slot="title">
                      <span>View Document</span>
                    </template>
                    <a-button @click="handleViewDoc(data)" icon="eye" type="primary"></a-button>
                  </a-tooltip>
                  <a-tooltip placement="bottomRight">
                    <template slot="title">
                      <span>Edit Transaction</span>
                    </template>
                    <a-button :disabled="data.edit_sts != 'enabled'" @click="handleEditLink(data)" icon="edit"
                      type="danger"></a-button>
                  </a-tooltip>
                </a-button-group>
              </template>
            </a-table>
          </a-tab-pane>
          <a-tab-pane tab="Canceled" key="cancel_list">
            <a-table :rowKey="(record, index) => { return index.toString(); }" size="small" bordered :scroll="{ x: 1300 }"
              :columns="columns.invoice_list" :dataSource="cancel_list" :loading="tabs.loading">
              <template slot="nomor" slot-scope="text, data, index">
                <span>{{ index + 1 }}</span>
              </template>
              <template slot="createBy" slot-scope="text, data">
                <h4 class="margin-remove">{{ data.tlc_create }}</h4>
                <span>{{
                  moment(data.create_dt).format(getDefaultDateFormat)
                }}</span>
              </template>
              <template slot="duedate" slot-scope="text, data">
                <span>{{
                  moment(data.due_date).format(getDefaultDateFormat)
                }}</span>
              </template>
              <template slot="value" slot-scope="text, data">
                <span>{{ formatCurrency(data.mata_uang, data.invoice_value) }}</span>
              </template>
              <template slot="nama_supplier" slot-scope="text, data">
                <span>{{ data.nama_supplier }}</span><br />
                <i><small>Alamat : {{ data.alamat_supplier }}</small></i>
              </template>
              <template slot="aksi" slot-scope="text, data">
                <a-button-group>
                  <a-tooltip placement="bottomRight">
                    <template slot="title">
                      <span>View Manifest</span>
                    </template>
                    <a-button @click="handleManifest(data)" icon="file"></a-button>
                  </a-tooltip>
                  <!-- <a-tooltip placement="bottomRight">
                    <template slot="title">
                      <span>View Document</span>
                    </template>
                    <a-button @click="handleViewDoc(data)" icon="eye" type="primary"></a-button>
                  </a-tooltip>
                  <a-tooltip placement="bottomRight">
                    <template slot="title">
                      <span>Edit Transaction</span>
                    </template>
                    <a-button :disabled="data.edit_sts != 'enabled'" @click="handleEditLink(data)" icon="edit"
                      type="danger"></a-button>
                  </a-tooltip> -->
                </a-button-group>
              </template>
            </a-table>
          </a-tab-pane>
        </a-tabs>
      </div>
    </div>

    <a-modal v-model="modalBuktiTransfer" title="Bukti Transfer" :width="500" centered :maskClosable="false">
      <template slot="footer">
        <a-button @click="handleClose()">Tutup</a-button>
      </template>
      <a-list :dataSource="buktiTransfer">
        <a-list-item class="list-item" slot="renderItem" slot-scope="item">
          <div>
            <h4 class="margin-remove">
              {{
                `${moment(item.tgl_tf).format(getDefaultDateFormat)} | ${item.user_tf
                }`
              }}
            </h4>
            <span>{{ formatCurrency(item.currency, item.value_tf) }}</span>
          </div>
          <a-button @click="handleDownload(item)" size="small">Download</a-button>
        </a-list-item>
      </a-list>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import shortingArray from "@/mixins/MultishortArray";
import GlobalMethod from "@/mixins/GlobalMethod.js";

export default {
  name: "Invoice-List",
  mixins: [CurrencyFormat, HandleRoute, shortingArray, GlobalMethod],
  data() {
    const columns = {
      invoice_list: [
        {
          title: "#",
          key: "nomor",
          scopedSlots: { customRender: "nomor" },
          width: 40,
          align: "center",
        },
        {
          title: "No",
          key: "no",
          dataIndex: "no_inv_ap_ad",
          width: 230,
        },
        {
          title: "Deskripsi",
          key: "deskripsi",
          dataIndex: "catatan",
          width: 250,
        },
        {
          title: "Supplier",
          key: "supplier",
          width: 250,
          scopedSlots: { customRender: "nama_supplier" },
        },
        {
          title: "No Invoice",
          key: "no_invoice",
          width: 150,
          dataIndex: "no_invoice",
        },
        {
          title: "Create By",
          key: "create_by",
          scopedSlots: { customRender: "createBy" },
          width: 150,
        },
        {
          title: "Due Date",
          key: "due_date",
          scopedSlots: { customRender: "duedate" },
          width: 150,
        },
        {
          title: "Value",
          key: "value",
          scopedSlots: { customRender: "value" },
          width: 150,
          align: "right",
        },
        {
          title: "Action",
          key: "number",
          dataIndex: "number",
          width: 120,
          scopedSlots: { customRender: "aksi" },
          align: "center",
          fixed: "right"
        },
      ],
      needProcess: [
        {
          title: "#",
          key: "nomor",
          scopedSlots: { customRender: "nomor" },
          width: 40,
          align: "center",
        },
        {
          title: "No",
          key: "no",
          dataIndex: "no",
          width: 200,
        },
        {
          title: "Description",
          key: "deskripsi",
          dataIndex: "deskripsi",
        },
        {
          title: "Supplier",
          key: "nama_supplier",
          dataIndex: "nama_supplier",
        },
        {
          title: "Value",
          key: "value",
          scopedSlots: { customRender: "value" },
          width: 150,
          align: "right",
        },
        {
          title: "Remaining Balance",
          key: "sisa_trf",
          scopedSlots: { customRender: "sisatransfer" },
          width: 150,
          align: "right",
        },
        {
          title: "Action",
          fixed: "right",
          scopedSlots: { customRender: "aksi" },
          width: 170,
          align: "left",
        },
      ],
    };
    return {
      columns,
      tabs: {
        active: "needprocess",
        loading: false,
      },
      invoice_list: [],
      needProcess: [],
      cancel_list: [],
      invoice_list_origin: [],
      needProcess_origin: [],
      cancel_list_origin: [],
      supplier_invoice_list: [],
      supplier_cancel_list: [],
      supplier_need_process: [],
      search: undefined,
      typetransaction: "all",
      typeinvoice: "all",
      transactionDt: [],
      buktiTransfer: [],
      modalBuktiTransfer: false,
      advancedsearch: "display:none",
      needProcessSuplier: [],
      quequeSuplier: [],
      listSuplier: [],
      supplier_nm: undefined,
      revisedStatus: "all",
      loading: {
        revisedkey: "",
        revised: false
      }
    };
  },
  mounted() {
    Event.$on("confirmRevisedReturn", this.handleRevisedLinkProcess);
    if (this.isAkuntansi) {
      this.tabs.active = "needprocess";
    }
  },
  beforeDestroy() {
    Event.$off("confirmRevisedReturn", this.handleRevisedLinkProcess);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    isAkuntansi() {
      return this.$route.name == "Spclaccount-pay-index" &&
        this.$route.path == "/akuntansiKeuangan/account_pay"
        ? true
        : false;
    },
    moreSearch: function () {
      let tempData = [];
      if (this.tabs.active == "invoice_list") {
        tempData = this.invoice_list_origin;
      } else if (this.tabs.active == "cancel_list") {
        tempData = this.cancel_list_origin;
      } else {
        tempData = this.needProcess_origin;
      }

      if (tempData.length > 0) {
        if (this.search && this.tabs.active == "invoice_list") {
          tempData = tempData.filter(
            (obj) =>
              (obj.no_inv_ap_ad &&
                obj.no_inv_ap_ad
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.no_transaksi &&
                obj.no_transaksi
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.catatan &&
                obj.catatan.toLowerCase().indexOf(this.search.toLowerCase()) >=
                0) ||
              (obj.nama_supplier &&
                obj.nama_supplier
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.no_bkk &&
                obj.no_bkk.toLowerCase().indexOf(this.search.toLowerCase()) >=
                0) ||
              (obj.no_invoice &&
                obj.no_invoice.toLowerCase().indexOf(this.search.toLowerCase()) >=
                0) ||
              (obj.due_date &&
                this.moment(obj.due_date)
                  .format(this.getDefaultDateFormat)
                  .toString()
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.value &&
                this.formatCurrency(obj.mata_uang, obj.value)
                  .toString()
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.tlc_create &&
                obj.tlc_create
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0)
          );
          this.intoList(this.tabs.active, tempData);
        } else if (this.search && this.tabs.active == "cancel_list") {
          tempData = tempData.filter(
            (obj) =>
              (obj.no_inv_ap_ad &&
                obj.no_inv_ap_ad
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.no_transaksi &&
                obj.no_transaksi
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.catatan &&
                obj.catatan.toLowerCase().indexOf(this.search.toLowerCase()) >=
                0) ||
              (obj.nama_supplier &&
                obj.nama_supplier
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.no_bkk &&
                obj.no_bkk.toLowerCase().indexOf(this.search.toLowerCase()) >=
                0) ||
              (obj.due_date &&
                this.moment(obj.due_date)
                  .format(this.getDefaultDateFormat)
                  .toString()
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.value &&
                this.formatCurrency(obj.mata_uang, obj.value)
                  .toString()
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.tlc_create &&
                obj.tlc_create
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0)
          );
          this.intoList(this.tabs.active, tempData);
        } else if (this.search && this.tabs.active == "needprocess") {
          tempData = tempData.filter(
            (obj) =>
              (obj.no &&
                obj.no.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.deskripsi &&
                obj.deskripsi
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.nama_supplier &&
                obj.nama_supplier
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.value &&
                this.formatCurrency(obj.mata_uang, obj.value)
                  .toString()
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.sisa_trf &&
                this.formatCurrency(obj.mata_uang, obj.sisa_trf)
                  .toString()
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0)
          );
          this.intoList(this.tabs.active, tempData);
        }

        if (this.typetransaction && this.typetransaction !== "all") {
          //console.log("this.typetransaction",this.typetransaction)
          tempData = tempData.filter(
            (obj) =>
              obj.jenis_transaksi && obj.jenis_transaksi == this.typetransaction
          );
        }

        if (this.typeinvoice && this.typeinvoice !== "all") {
          tempData = tempData.filter(
            (obj) =>
              obj.invoice_type && obj.invoice_type == this.typeinvoice
          );
        }

        if (this.transactionDt && this.transactionDt.length > 0) {
          //console.log(this.transactionDt[0],this.transactionDt[1])
          let startDt = moment(this.transactionDt[0]).format("YYYY-MM-DD");
          let endDt = moment(this.transactionDt[1]).format("YYYY-MM-DD");
          tempData = tempData.filter(
            (obj) =>
              obj.create_dt &&
              moment(obj.create_dt).format("YYYY-MM-DD") >= startDt &&
              moment(obj.create_dt).format("YYYY-MM-DD") <= endDt
          );
        }

        if (this.supplier_nm != "" && this.supplier_nm != undefined) {
          tempData = tempData.filter(
            (obj) => obj.nama_supplier && obj.nama_supplier == this.supplier_nm
          );
        }

        if (this.tabs.active == "needprocess" && this.revisedStatus) {
          if (this.revisedStatus !== "all") {
            tempData = tempData.filter(
              (obj) => obj.button_aksi && obj.button_aksi == this.revisedStatus
            );
          }
        }
      }
      this.intoList(this.tabs.active, tempData);
      if (
        !this.tabs.active &&
        !this.search &&
        !this.transactionDt &&
        !this.typetransaction &&
        !this.typeinvoice
      ) {
        this.intoList(this.tabs.active, tempData);
      }
      return true;
    },
  },
  created() {
    this.tabs.loading = true;
    this.asyncAxiosGet("invoice",
      this.getAuth,
    ).then((res) => {
      this.cancel_list = res.invoice_cancel;
      this.invoice_list = res.invoice_list;
      this.needProcess = res.need_process;

      this.cancel_list_origin = res.invoice_cancel;
      this.invoice_list_origin = res.invoice_list;
      this.needProcess_origin = res.need_process;

      this.supplier_need_process = res.supplier_need_process;
      this.supplier_invoice_list = res.supplier_invoice_list;
      this.supplier_cancel_list = res.supplier_invoice_cancel;

      this.listSuplier = this.supplier_need_process;

      this.tabs.loading = false;
    }).catch((err) => {
      this.tabs.loading = false;
      let response = Object.assign({}, err.response);
      if (response.data.status == false && response.data.message) {
        this.displayMessageValue("error-other", response.data.message);
      } else {
        let responses = Object.assign({}, err.response.data);
        this.displayMessageValue("error", responses);
      }
    });
  },
  methods: {
    moment,
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    resetSearch() {
      this.search = undefined;
      this.transactionDt = undefined;
      this.typetransaction = "all";
      this.typeinvoice = "all";
      this.supplier_nm = "";
    },
    intoList(type, value) {
      if (type == "invoice_list") {
        this.invoice_list = value;
      } else if (type == "cancel_list") {
        this.cancel_list = value;
      } else {
        this.needProcess = value;
      }
    },
    handleReload() {
      this.tabs.loading = true;
      this.asyncAxiosGet("invoice",
        this.getAuth,
      ).then((res) => {
        this.cancel_list = res.invoice_cancel;
        this.invoice_list = res.invoice_list;
        this.needProcess = res.need_process;

        this.cancel_list_origin = res.invoice_cancel;
        this.invoice_list_origin = res.invoice_list;
        this.needProcess_origin = res.need_process;

        this.supplier_need_process = res.supplier_need_process;
        this.supplier_invoice_list = res.supplier_invoice_list;
        this.supplier_cancel_list = res.supplier_invoice_cancel;

        this.listSuplier = this.supplier_need_process;

        this.tabs.loading = false;
      }).catch((err) => {
        this.tabs.loading = false;
        let response = Object.assign({}, err.response);
        if (response.data.status == false && response.data.message) {
          this.displayMessageValue("error-other", response.data.message);
        } else {
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error", responses);
        }
      });
      this.resetSearch();
    },
    handleTab(val) {
      this.tabs.active = val;
      if (val == 'needprocess') {
        this.listSuplier = this.supplier_need_process;
      } else if (val == 'cancel_list') {
        this.listSuplier = this.supplier_cancel_list;
      } else {
        this.listSuplier = this.supplier_invoice_list;
      }
      this.resetSearch();
    },
    handleCreate(item) {
      this.$router.push({
        name: "invoice-create-ap",
        params: { id: item.id, type: item.jenis_transaksi },
      });
    },
    handleCreateGeneral(type) {
      this.$router.push({
        name: type == 'AP' ? "invoice-general-create-AP" : "invoice-general-create-AD"
      });
    },
    handleCreateAddendum(item) {
      this.$router.push({
        name: "invoice-create-ad",
        params: { id: item.id, type: item.jenis_transaksi },
      });
    },
    handleCreateGeneralAddendum() {
      this.$router.push({
        name: "createAddendumGeneral",
      });
    },
    handleManifestRef(item) {
      const data = {
        rest_api: item.jenis_transaksi.toLowerCase() == "adendum"
          ? item.jenis_transaksi.toLowerCase()
          : "accountpay",
        id_manifest: item.id_invoice_ap_ad,
        tlc: this.getAuth.username,
        user_pembuat: item.tlc_create,
      };

      this.handleView(data);
    },
    handleManifestRefNedProcess(item) {
      const data = {
        rest_api: item.jenis_transaksi
          ? item.jenis_transaksi.toLowerCase()
          : item.jenis.toLowerCase(),
        id_manifest: item.id,
        tlc: this.getAuth.username,
        user_pembuat: item.tlc_create,
      };

      this.handleView(data);
    },
    handleManifest(item) {
      this.$router.push({
        name: "invoice-manifest",
        params: { id: item.id_invoice_ap_ad },
      });
      // if(item.jenis_transaksi=="Adendum"){
      //   this.$router.push({
      //       name: "AddendumManifest",
      //       params: { id: item.id },
      //     });
      // }else{
      //   if (this.isAkuntansi) {
      //     this.$router.push({
      //       name: "Spclaccount-pay-manifest",
      //       params: { id: item.id_account_pay },
      //     });
      //   } else {
      //     this.$router.push({
      //       name: "account-pay-manifest",
      //       params: { id: item.id_account_pay },
      //     });
      //   }
      // }
    },
    handleDocument(item) {
      this.$store
        .dispatch("getBuktiAP", { auth: this.getAuth, id: item.id })
        .then((res) => {
          this.buktiTransfer = res.data.data;
          this.modalBuktiTransfer = true;
        });
    },
    handleDownload(item) {
      window.open(this.$serviceUrl + item.url, "_blank");
    },
    handleViewDoc(item) {
      window.open(this.$serviceUrl + item.url_file, "_blank");
    },
    handleClose() {
      this.modalBuktiTransfer = false;
    },
    handleshowMore() {
      if (this.advancedsearch == "display:none") {
        this.advancedsearch = "display:block";
      } else {
        this.advancedsearch = "display:none";
      }
    },

    handleRevisiAndClose(item) {
      const that = this;
      let title = "";
      let messageSukses = "";
      title = "Are you sure to revise this data";
      messageSukses = "Successfully revise data";

      this.$confirm({
        title: title,
        content: "Batal / OK?",
        onOk() {
          let promise = new Promise((resolve, reject) => {
            let data = {
              tlc: that.getAuth.username,
              aksi: item.button_aksi,
              id: item.id,
              jenis_transaksi: item.jenis_transaksi,
            };

            // try {
            //   resolve(data);
            // } catch {
            //   reject("error data");
            // }

            axios({
              method: "post",
              url: that.$serviceUrl + "account_pay/aksi_account_pay",
              data: data,
              auth: {
                username: that.getAuth.username,
                password: that.getAuth.password,
              },
              headers: {
                "Content-Type": "application/json",
                "X-API-KEY": that.getAuth.apikey,
              },
            })
              .then(({ data, status }) => {
                resolve(data);
              })
              .catch((err) => {
                reject(err);
              });
          }).catch(() => console.log("Oops errors!"));
          promise
            .then((value) => {
              that.displayMessageValue("success-other", messageSukses);
              that.handleReload();
            })
            .then((err) => {
              if (err) {
                let responses = Object.assign({}, err.response.data);
                that.displayMessageValue("error-other", responses.message);
              }
            });
          return promise;
        },
        onCancel() { },
      });
    },
    handleEditLink(data) {
      this.$router.push({
        name: data.invoice_type == "Adendum" ? "invoice-edit-ad" : "invoice-edit-ap",
        params: { id: data.id_invoice_ap_ad, type: data.jenis_transaksi_label, },
      });
    },
    handleRevisedLink(data) {
      this.$confirm({
        title: "Are you sure to Revise?",
        content: '',
        okText: 'Yes',
        cancelText: 'No',
        onOk() {
          Event.$emit("confirmRevisedReturn", data);
        },
        onCancel() { },
      });
    },
    handleRevisedLinkProcess(data) {
      this.loading.revisedkey = data.id;
      this.loading.revised = true;
      this.asyncAxiosPost(
        "invoice/aksi_invoice",
        "json",
        this.getAuth,
        {
          "aksi": "Revised",
          "jenis_transaksi": data.jenis_transaksi,
          "tlc": this.getAuth.username,
          "id": data.id
        }
      )
        .then((response) => {
          this.loading.revisedkey = "";
          this.loading.revised = false;
          const ref = {
            rest_api: data.jenis_transaksi.toLowerCase(),
            id_manifest: data.id,
            tlc: this.getAuth.username,
          };
          this.handleView(ref);
        })
        .catch((err) => {
          this.loading.revisedkey = "";
          this.loading.revised = false;
          let response = Object.assign({}, err.response);
          if (response.data.status == false && response.data.message) {
            this.displayMessageValue("error-other", response.data.message);
          } else {
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error", responses);
          }
        });
    }
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  border: 1px solid darken(white, 10);

  &-header {
    height: 50px;
    background: darken(white, 2);
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-transform: capitalize;
    font-size: 1rem;
    font-weight: 500;
    color: @color-secondary;
    border-bottom: 1px dashed darken(white, 10);
    padding: @padding;
  }

  &-body {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}

.bordered {
  border: 1px solid darken(white, 10);
}

.custom-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.list-item {
  display: flex;
  align-items: flex-start;
}
</style>

<style lang="less">
.custom-tabs {
  .ant {
    &-tabs-bar {
      margin-bottom: 0;
    }

    &-tabs-content {
      flex: 1;
    }
  }
}

.ant-table-thead>tr>th {
  text-align: center;
}
</style>
